import svgUrl from "ni:svgr;61lR5s4GB8MSjvF64Zfg1-1mYFtgz9iJOc7wQJzat2Q";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SortByAscendingLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--clean--secondary)" d="M25.5 25H4V6.835c0-.88 1.054-1.33 1.69-.724L25.5 25Z" /><path fill="var(--tbl--colors--icons--clean--primary)" fillRule="evenodd" d="M25 6a1 1 0 1 0-2 0v8.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L25 14.586V6ZM5 24a1 1 0 1 0 0 2h19.5a1 1 0 1 0 0-2H5Z" clipRule="evenodd" /></svg>;
const Memo = memo(SortByAscendingLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "SortByAscendingLIcon";
}